const {
  getDetailRequest,
  patchRequest,
  patchMultipartRequest,
  postRequest,
} = require("./axiosRequest");

const url = `${process.env.REACT_APP_SERVER_URI}/api/v1/user`;

export const postUser = (body) => postRequest(url, body);
export const getUserDetail = (param) => getDetailRequest(url, param);
export const patchUserProfile = (body) =>
  patchMultipartRequest(`${url}/profile`, body);
export const patchUserPassword = (body) =>
  patchRequest(`${url}/password`, body);
export const postUserVerification = (body) =>
  postRequest(`${url}/verification`, body);
export const postPasswordForget = (body) =>
  postRequest(`${url}/password/forget`, body);
export const postPasswordVerification = (body) =>
  postRequest(`${url}/password/verification`, body);
